import { Blockchain } from "@rarible/api-client"
import { toCurrencyId } from "../../../price/types"
import { FEE_CONFIG_URL } from "../constants"
import type { StaticEthereumBlockchainConfig } from "../types"

export const rariConfig: StaticEthereumBlockchainConfig = {
  name: "RARI",
  icon: "/images/blockchains/rari.svg",
  isEvm: true,
  isTestnet: false,
  testnet: false,
  feesVersion: "v3",
  unionApi: "https://api.rarible.org",
  basePath: "https://rari-api.rarible.org",
  chainId: 1380012617,
  blockchain: Blockchain.RARI,
  treasury: "0x64d34BcfC32Fb663172C47d6E4Fb1dBFaba6e7a2",
  chainName: "RARI Chain",
  exchange: {
    v2: "0x10CCBf49617ECB7A8262065853D6C93Ad42C3C2C",
    wrapper: "0xd37DC0CD86Dfa9B2B57CD7DFA8B6AA0092a9517d",
  },
  blockExplorers: [
    {
      url: "https://mainnet.explorer.rarichain.org/",
      icon: "/images/scanner.svg",
      adress: "https://mainnet.explorer.rarichain.org/address/${adrress}",
    },
  ],
  rpcUrls: [],
  privateRpcNodeSlug: "rari-node",
  transferProxies: {
    nft: "0xce4bf732f53A76C463aE8822be858017b02779c8",
    erc721Lazy: "0xBCE7d7fbA750B1E9e0511C67b1F38C07EbfEFE63",
    erc20: "0x1CC22424f2B84791cb99c141A68CD2a44Cf35398",
  },
  feeConfigUrl: FEE_CONFIG_URL,
  primaryCurrency: {
    id: toCurrencyId("RARI:0x0000000000000000000000000000000000000000"),
    symbol: "ETH",
    name: "Ether (Rari)",
    decimals: 18,
  },
  wrappedCurrency: {
    id: toCurrencyId("RARI:0xf037540e51d71b2d2b1120e8432ba49f29edfbd0"),
    symbol: "WETH",
    name: "wETH (Rari)",
    decimals: 18,
  },
  addFundsLink: "https://rarible.com/rari/swap",
  hasStabilityProtocol: false,
  viem: {
    id: 1380012617,
    name: "RARI Chain",
    nativeCurrency: {
      decimals: 18,
      name: "Ether (Rari)",
      symbol: "ETH",
    },
    rpcUrls: {
      default: { http: ["https://mainnet.rpc.rarichain.org/http"] },
    },
    blockExplorers: {
      default: {
        name: "RARI Chain",
        url: "https://mainnet.explorer.rarichain.org",
      },
    },
    testnet: false,
  },
}

export const getRariConfig = (): StaticEthereumBlockchainConfig => rariConfig
